import { useState, useEffect, useContext, useMemo } from 'react'
import { RootContext } from 'store/root'
import { AlertContext } from 'store/alert'
import filters from 'lib/filters'

import useCreateStore from '../../lib/useCreateStore'
import filterActions from './actions'
import filterSelectors from './selectors'

// Store para armazenar os dados de filtro selecionados pelo usuário

export const initialState = {
  slug: '',
  locality: undefined,
  localities: [],
  selectedLocalities: [],
  searchId: '',
  estatesList: [],
  valueRange: { ...filters.initialValueRange },
  desagio: 0,
  visits: false,
  noLegalActions: false,
  saleCategory: '',
  campaigns: {
    campaign: false,
    secondCampaign: false,
  },
  currentBannerList: [],
  surroundingsSearch: false,
  noDebts: false,
  apiFilters: undefined,
  initialFilters: {},
  filters: {},
  page: 1,
  orderBy: 'data',
  query: '',
  presetProfile: false,
  filtersModal: {
    openModal: false,

    showReducedFilters: false,
  },
}

const FilterStore = useCreateStore(() => {
  const [$filter, setFilter] = useState(initialState)
  const selectors = filterSelectors($filter, initialState)
  const { setError } = useContext(RootContext)
  const { getOpenModal } = useContext(AlertContext)
  const actions = useMemo(
    () => filterActions(setFilter, setError, initialState),
    [setError]
  )

  useEffect(() => {
    actions.fetchFilters()
    actions.getLocalities()
  }, [actions])

  useEffect(() => {
    // TODO: remove condition when filter is dumb component
    if (!getOpenModal()) {
      actions.updateQuery()
    }
  }, [actions, getOpenModal, $filter])

  return { $filter, setFilter, ...actions, ...selectors }
})

export const useFilter = () => FilterStore()
export const FilterContext = FilterStore.Context
export const FilterProvider = FilterStore.Provider
